import { useEffect, useState } from "react";
import api from "../lib/api";
import { Video } from "lucide-react";
import { T } from "../lib/i18n";

function embedUrl(url) {
  if (!url) return null;
  try {
    const u = new URL(url);
    if (u.hostname.includes("youtube.com")) {
      const v = u.searchParams.get("v");
      if (v) return `https://www.youtube.com/embed/${v}?autoplay=1`;
      // /live/<id>
      const m = u.pathname.match(/\/live\/([^/]+)/);
      if (m) return `https://www.youtube.com/embed/${m[1]}?autoplay=1`;
    }
    if (u.hostname === "youtu.be") {
      return `https://www.youtube.com/embed/${u.pathname.slice(1)}?autoplay=1`;
    }
    if (u.hostname.includes("vimeo.com")) {
      const id = u.pathname.split("/").filter(Boolean).pop();
      if (id) return `https://player.vimeo.com/video/${id}?autoplay=1`;
    }
  } catch {}
  return null;
}

export default function LivestreamPlayer() {
  const [event, setEvent] = useState(null);

  useEffect(() => {
    api.get("/events/current").then(({ data }) => setEvent(data));
  }, []);

  const url = event?.livestream_url;
  const src = embedUrl(url);

  return (
    <div className="space-y-3 fadein">
      <h2 className="font-display text-2xl text-motif">{T("Livestream")}</h2>
      {!url && (
        <div className="card-elev p-8 text-center text-motif-muted">
          <Video className="w-8 h-8 mx-auto mb-2 text-primary-motif" strokeWidth={1.2} />
          <div className="text-sm">{T("The livestream will appear here once the couple starts it.")}</div>
        </div>
      )}
      {url && !src && (
        <div className="card-elev p-5 space-y-2">
          <div className="text-sm text-motif">{event.livestream_title || "Livestream"}</div>
          <a href={url} target="_blank" rel="noreferrer" className="btn-primary text-xs inline-block">
            Open stream
          </a>
        </div>
      )}
      {src && (
        <div className="card-elev p-3 space-y-2">
          {event.livestream_title && (
            <div className="text-xs tracking-luxe text-motif-muted">{event.livestream_title}</div>
          )}
          <div className="aspect-video w-full rounded-xl overflow-hidden bg-black">
            <iframe
              src={src}
              title="Livestream"
              className="w-full h-full"
              allow="autoplay; encrypted-media; picture-in-picture"
              allowFullScreen
              data-testid="livestream-iframe"
            />
          </div>
        </div>
      )}
    </div>
  );
}
